<!-- 预测冠军 -->
<template>
<div class="forecast">
    <ul class="city-list">
        <li class="first" v-if="topTeams[1]"><div class="box">
            <div class="tag"><img :src="require('../assets/top2.png')" alt=""></div>
            <img class="city"  :src="topTeams[1].imageUrl" alt="">
            <div class="txt">{{topTeams[1].name}}</div>
        </div></li>
        <li class="second" v-if="topTeams[0]"><div class="box">
            <div class="tag"><img :src="require('../assets/top1.png')" alt=""></div>
            <img class="city" :src="topTeams[0].imageUrl" alt="">
            <div class="txt">{{topTeams[0].name}}</div>
        </div></li>
        <li class="third" v-if="topTeams[2]"><div class="box">
            <div class="tag"><img :src="require('../assets/top3.png')" alt=""></div>
            <img class="city" :src="topTeams[2].imageUrl" alt="">
            <div class="txt">{{topTeams[2].name}}</div>
        </div></li>
    </ul>
    <div class="win cont-row">
        <img :src="require('../assets/win-cup.png')" alt="">
        <div class="flex-cont forecast-info">
            <div class="main">预测冠军</div>
            <div class="info-text">{{joinTotal}}人参与活动</div>
        </div>
        <div class="cont now-guessing" @click="guessingChampionStatus =true"><img :src="require('../assets/forecast.png')" alt=""></div>
    </div>
    <GuessingChampion :status.sync="guessingChampionStatus" />
</div>
</template>
<script>
import GuessingChampion from '../dialog/guessing-champion.vue'
export default {
    name:'Forecast',
    components:{GuessingChampion},
    data(){
        return {
            guessingChampionStatus:false,  
            topTeams:[],
            joinTotal:0

        }
    },
    created(){
        this.getTopList()
    },
    methods:{
        win(){
            console.log(22)
        },
        async getTopList(){
            let result = await this.$axios.get('/worldcup2022/game/coin/champion/game/top3');
            console.log('夺冠top3---》',result);
            if(result.code == 0 ){
                this.topTeams = result.data.teams;
                this.joinTotal = result.total;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.forecast{
    position: relative;
    background:linear-gradient(135deg,#a121c0 0%, #5900bc 91%);
    border-radius: 0px 0px 8px 8px; overflow: hidden;padding:10px 10px 0; margin-bottom: 30px;
    *{position: relative; z-index: 2;}
    .city-list{ background: #fff; border-radius: 7px; display: flex; padding: 30px 6px 0; align-items: flex-start; overflow: hidden;
        li{
            width:33.33%; padding: 0 6px; margin-bottom: 15px;
            .box{
                position: relative;
                .city{display: block;border: 1px solid rgba(225,225,225,0.40)}
                .tag{position: absolute; z-index: 5; left: 50%; transform: translateX(-50%) translateY(-20px);}
                .txt{font-size: 14px; line-height: 20px; color: #333; text-align: center; margin-top: 10px;}
            }
            &.first{margin-top: 20px;}
            &.third{margin-top: 25px;}
        }
    }
    &:after{
        position: absolute; z-index: 0; content: ''; right: 0; bottom: 0; width: 100%; height: 100%; background: url('../assets/forecast-g.png') no-repeat right bottom ;
    }

    .forecast-info{
        .main{font-size: 20px; line-height: 28px; color: #fff; margin-top: 5px;}
        .info-text{font-size: 12px; line-height: 18px; color: #fff; opacity: 0.5;}
    }
}
.now-guessing{user-select: none; cursor: pointer;}
@media screen and (max-width:768px){
    .forecast{
        margin-bottom: 10px;
        .city-list{
            display: none;;
        }
    }
}
</style>